import posthog, { type SessionRecordingOptions } from 'posthog-js'

const posthogKey = import.meta.env.VITE_POSTHOG_KEY
const posthogHost = import.meta.env.VITE_POSTHOG_HOST

const sessionRecordingWithCanvas = {
  captureCanvas: {
    canvasFps: 4,
    canvasQuality: '0.4',
  },
} as SessionRecordingOptions

let initialized = false

const canInitializePostHog =
  import.meta.env.PROD && Boolean(posthogKey && posthogHost)

/**
 * Pinned to 1.105.7 for session replay canvas capture.
 * Enable canvas recording in PostHog project settings (Session replay).
 */
export function initPostHog(): boolean {
  if (initialized || !canInitializePostHog) {
    return initialized
  }

  posthog.init(posthogKey, {
    api_host: posthogHost,
    capture_pageleave: true,
    capture_pageview: false,
    session_recording: sessionRecordingWithCanvas,
  })
  initialized = true

  return true
}

export function isPostHogInitialized(): boolean {
  return initialized
}

export { posthog }
